import type { DialogueSystemMessage } from 'components/Dialogue/types';
import { SystemMessage } from 'components/Dialogue';
import { BaseMsgProps } from './types';
import { DistributeButton } from '../DistributeDetail';

interface SystemMsgProps extends BaseMsgProps {
  skipHistoryDivider: boolean;
  // 会话分流记录按钮
  showDistributeButton?: boolean;
}

export const SystemMsg = (props: SystemMsgProps) => {
  const { showDistributeButton, msg } = props;

  const dataSource = (msg as DialogueSystemMessage).content;
  const extra = dataSource?.extra ? (
    <>
      <br />
      {dataSource.extra}
    </>
  ) : null;

  return (
    <>
      {dataSource?.ignore ? null : (
        <SystemMessage>
          <>
            {dataSource.text}
            {extra}
            {showDistributeButton && <DistributeButton id={msg.raw.conversationId} />}
          </>
        </SystemMessage>
      )}
    </>
  );
};
